<template>
  <div id="AddPhoneCodeView" class="add-phone-code-view">
    <b-row class="justify-content-end pt-3">
      <b-col sm="8">
        <b-button variant="outline-primary" @click.prevent="$emit('addItem')" class="icon-container">
          <i class="material-icons mr-2">note_add</i> Add phone code
        </b-button>
      </b-col>
      <b-col sm="3">
        <b-form-input v-model="tableFilter" type="text" placeholder="Filter"></b-form-input>
      </b-col>
      <b-col sm="1">
        <b-button variant="danger" @click.prevent="showModal" :disabled="selection.length === 0" class="icon-container">
          <i class="material-icons">delete_forever</i>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="">
        <b-table striped
          :items="phoneCodes"
          :fields="fields"
          :filter="tableFilter"
          @sort-changed="sortingChanged"
          :sort-compare="compareRows"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-direction="sortDirection"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc">
          <template slot="select" slot-scope="data">
            <p-check class="p-icon p-smooth" name="toProcess" color="info" v-model="selection" :value="data.item.id" style="font-size: 16px;">
              <i slot="extra" class="icon material-icons">done</i>
            </p-check>
          </template>
          <template slot="countryName" slot-scope="data">
            <router-link :to="{ name: 'editPhoneCode', params: { id: data.item.id } }">{{data.item.countryName}}</router-link>
          </template>
          <template slot="pageTitle" slot-scope="data">
            {{ data.item.pageTitle }}
          </template>
        </b-table>
        <b-pagination v-if="isPaginationShown()" align="center" :total-rows="phoneCodes.length" :per-page="perPage" v-model="currentPage"></b-pagination>
      </b-col>
    </b-row>
    <b-modal id="modal-center" centered title="Are you sure?" footer-class="d-flex justify-content-center border-0">
      <div class="modal-body">
        <p>Delete selected phone code?</p>
      </div>
      <div slot="modal-footer">
        <b-button variant="danger" size="lg" @click.prevent="deleteSelected">Yes, delete</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import IcgLeftNav from '@/components/layout/IcgLeftNav'
import Header from '@/components/layout/Header'
import PhoneCodesTabs from '@/components/PhoneCodesTabs'
import { sortByString } from '@/util/sorting'
export default {
  name: 'PhoneCodes',
  components: {
    Header,
    PhoneCodesTabs,
    IcgLeftNav
  },
  async created () {
    await this.fetchPhoneCodes(this.locale).catch(err => this.$toastr.e(err))
  },
  methods: {
    ...mapActions({
      'fetchPhoneCodes': 'icg/fetchPhoneCodes',
      'deletePhoneCode': 'icg/deletePhoneCode'
    }),
    compareRows (a, b) {
      return sortByString(this.sortBy, this.sortDesc, a, b)
    },
    sortingChanged (ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
    },
    isPaginationShown () {
      return this.phoneCodes.length > this.perPage
    },
    showModal () {
      this.$root.$emit('bv::show::modal', 'modal-center')
    },
    async deleteSelected () {
      if (this.selection.length === 0) {
        this.$toastr.w('Please select a phone code')
      } else {
        for (var id of this.selection) {
          try {
            await this.deletePhoneCode({id: id, locale: this.locale})
            this.$toastr.s('Phone code deleted')
          } catch (ex) {
            console.error(ex)
            this.$toastr.e('Error deleting phone code')
          }
        }
        this.tableFilter = ''
        this.selection = []
        await this.fetchPhoneCodes(this.locale).catch(err => this.$toastr.e(err))
        this.$root.$emit('bv::hide::modal', 'modal-center')
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'loader/isLoading',
      phoneCodes: 'icg/phoneCodes'
    })
  },
  data () {
    return {
      locale: 'en',
      selection: [],
      sortBy: 'countryName',
      sortDesc: true,
      sortDirection: 'asc',
      tableFilter: null,
      isRefreshing: false,
      perPage: 50,
      currentPage: 1,
      fields: [
        { key: 'select', label: '', class: 'check' },
        { key: 'countryName', label: 'Country', sortable: true },
        { key: 'pageTitle', label: 'Page title', sortable: true }
      ]
    }
  }
}
</script>
<style lang="scss">
td.check {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/icg/PhoneCodes.vue